import { AbstractCommand } from 'src/models/command';
import { Note } from 'src/models/note';

class ProcessNoteCommand extends AbstractCommand {
	readonly name = 'IFS_DesktopModule_Task_Command_Command_ProcessTaskCommand';

	public constructor(note: Note) {
		super();
		this.parameters = {
			aggregateId: note.aggregateId,
			aggregateVersion: note.aggregateVersion,
			alarmConfig: note.alarmConfig,
			content: note.content,
			fixedMaturityDate: note.fixedMaturityDate,
			forerunTime: note.forerunTime,
			processId: note.processId,
			repetitionConfig: note.repetitionConfig,
			responsibleUserId: note.responsibleUserId,
			title: note.title,
		};
	}
}

export { ProcessNoteCommand };
